export const topicsKey = {
  getSuggestedTopicsKey: (
    themeId: string | undefined,
    themeKeywordIds: string[],
    queryParams: {
      keyword?: string[]
      lte?: number
      gte?: number
      page: number
      limit: number
    }
  ) => ['topic-suggestion', themeId, themeKeywordIds, queryParams],
}
